import { Button, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AppDataWrapper from '../../../components/containers/AppDataWrapper'
import { useNavigate } from 'react-router-dom'
import { useContext } from 'react'
import { TicketsOpModuleContext } from '../context/TicketsOperationContext'
import FormModalNewTicket from './FormModalNewTicket'

export default function GridTicketsData() {
    const navigate = useNavigate();
    const context = useContext(TicketsOpModuleContext);
    return (
        <AppDataWrapper
            optionAppend={<Button
                variant='contained'
                className='app-btn-color-third'
                size='small'
                onClick={() => context?.setShowForm(true)}>
                + Nuevo ticket
            </Button>}>
            <div className='ticket'>
                {context?.workflow.map(status => <fieldset className='ticket-grid' key={status.id}>
                    <Typography component={'legend'} sx={{ color: 'text.secondary' }} variant='body2'>{status.name}</Typography>
                    {status.issues.map(t => <div
                        className='ticket-grid-card'
                        key={t.id}
                        role='button'
                        onClick={() => navigate(`${context.path}/detalle/${t.key}`)}
                        tabIndex={0}
                    >
                        <div className='ticket-grid-card-header'>
                            <h4><FontAwesomeIcon icon="ticket" /> {t.key}</h4>
                            {t.created && <Typography sx={{ color: 'text.secondary', textAlign: 'right' }} variant='caption' component={'div'}>
                                <small>{t.created?.slice(0, 16).replace('T', ' ')}</small>
                            </Typography>}
                        </div>
                        <div className='ticket-grid-card-body'>
                            <Typography variant='caption' component={'div'}>
                                {t.summary}
                            </Typography>
                        </div>
                        <div className='d-flex'>
                            {t.updated && <Typography variant='caption' sx={{ color: 'text.secondary' }} component={'div'}>
                            <small><FontAwesomeIcon icon={'clock'} /> Actualizado: {t.updated.slice(0, 10)?.slice(0, 16).replace('T', ' ')}</small>
                        </Typography>}
                            <div className='m-l-auto ticket-circle' style={{background: t.status.color}}></div>
                        </div>
                    </div>)}
                </fieldset>)}
            </div>
            <FormModalNewTicket />
        </AppDataWrapper>
    )
}
